import { Database, FileJson, Upload } from "lucide-react";
import { useState } from "react";
import { toast } from "sonner";

import { PageHeader } from "../components/PageHeader";
import api, { apiError } from "../lib/api";

const initialJson = `{
  "users": [],
  "matches": [],
  "ratings": [],
  "transactions": []
}`;

export default function ImportDataPage() {
  const [content, setContent] = useState(initialJson);
  const [importing, setImporting] = useState(false);
  const [result, setResult] = useState(null);

  const importJson = async (event) => {
    event.preventDefault();
    let data;
    try {
      data = JSON.parse(content);
    } catch {
      toast.error("O conteúdo precisa ser um JSON válido.");
      return;
    }
    const keys = ["users", "matches", "ratings", "transactions"];
    if (!keys.every((key) => Array.isArray(data[key]))) {
      toast.error("Inclua as quatro listas: users, matches, ratings e transactions.");
      return;
    }
    setImporting(true);
    try {
      const response = await api.post("/admin/import", data);
      setResult(response.data.imported);
      toast.success("Dados importados com sucesso.");
    } catch (error) {
      toast.error(apiError(error));
    } finally {
      setImporting(false);
    }
  };

  return (
    <>
      <PageHeader title="Importar Dados" subtitle="Migre as informações do app atual." back />
      <form className="page-content import-page" onSubmit={importJson} data-testid="import-data-form">
        <section className="import-note" data-testid="import-data-note">
          <Database size={21} />
          <p>Envie um JSON com <strong>users</strong>, <strong>matches</strong>, <strong>ratings</strong> e <strong>transactions</strong>. Registros com o mesmo identificador serão atualizados.</p>
        </section>
        <label className="import-label" htmlFor="import-json">JSON para importar</label>
        <textarea id="import-json" value={content} onChange={(event) => setContent(event.target.value)} spellCheck="false" data-testid="import-json-textarea" />
        <button className="button button-primary import-button" disabled={importing} data-testid="import-data-button">
          <Upload size={18} />
          {importing ? "Importando..." : "Importar"}
        </button>
        {result && <section className="import-result" data-testid="import-result"><FileJson size={19} /><div><strong>Importação concluída</strong><span>{result.users} usuários · {result.matches} peladas · {result.ratings} avaliações · {result.transactions} transações</span></div></section>}
      </form>
    </>
  );
}